import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body } from "@components/Typography";
import { DateFormat } from "@ctypes";
import { i18n, Translations } from "@i18n";
import {
  ModalType,
  UpdateTransferModalProps,
} from "@routes/TransfersRoute/TransactionList/UpdateTransferModal/types";
import dayjs from "dayjs";
import { CheckMark } from "./CheckMark";
import { useStyles } from "./styles";

export const StepCounter = ({ item, type = ModalType.Contribution }: UpdateTransferModalProps) => {
  const styles = useStyles();

  const isContribution = type === ModalType.Contribution;

  const processingLabel = (() => {
    if (item.completedDate) {
      return i18n.t(Translations.UpdateTransferModalCompletedText);
    }
    return i18n.t(Translations.UpdateTransferModalProcessingText);
  })();

  const completedContributionLabel = (() => {
    if (item.completedDate) {
      return dayjs(item.completedDate).format(DateFormat.ShortDate);
    }
    if (item.estimatedCompletionDateRange) {
      return i18n.t(Translations.UpdateTransferModalEstimatedDate, {
        date: item.estimatedCompletionDateRange,
      });
    }
    return "";
  })();

  const completedWithdrawalLabel = (() => {
    if (item.completedDate) {
      return dayjs(item.completedDate).format(DateFormat.ShortDate);
    }
    return i18n.t(Translations.UpdateTransferModalWithdrawalEstimationText);
  })();

  const scheduledLabelTitle = isContribution
    ? i18n.t(Translations.UpdateTransferModalContributionScheduled)
    : i18n.t(Translations.UpdateTransferModalWithdrawalScheduled);

  const processingLabelTitle = isContribution
    ? i18n.t(Translations.UpdateTransferModalContributionProcessing)
    : i18n.t(Translations.UpdateTransferModalWithdrawalProcessing);

  const completedLabelTitle = isContribution
    ? i18n.t(Translations.UpdateTransferModalContributionCompleted)
    : i18n.t(Translations.UpdateTransferModalWithdrawalCompleted);

  const completedLabel = isContribution ? completedContributionLabel : completedWithdrawalLabel;

  const steps = [
    {
      text: scheduledLabelTitle,
      subText: item.scheduledDate
        ? dayjs(item.scheduledDate).format(DateFormat.ShortDate)
        : i18n.t(Translations.TransfersRouteUnknownDate),
      completed: Boolean(item.scheduledDate || item.processingDate || item.completedDate),
    },
    {
      text: processingLabelTitle,
      subText: processingLabel,
      completed: Boolean(item.processingDate || item.completedDate),
    },
    {
      text: completedLabelTitle,
      subText: completedLabel,
      completed: Boolean(item.completedDate),
    },
  ];

  return (
    <div style={styles.container}>
      {steps.map((step, index) => {
        const lineStyle = step.completed ? styles.activeLine : styles.inactiveLine;

        return (
          <div key={index} style={styles.step}>
            <div style={styles.stepInner}>
              {step.completed ? (
                <CheckMark />
              ) : (
                <div style={styles.stepIncomplete}>
                  <div style={styles.stepIncompleteInner} />
                </div>
              )}
              {index < steps.length - 1 && <div style={{ ...styles.line, ...lineStyle }} />}
            </div>
            <div style={styles.content}>
              <Body style={styles.title}>{step.text}</Body>
              <Spacing size={SpacingSizes.XXS} />

              <Body style={styles.subtitle}>{step.subText}</Body>
            </div>
          </div>
        );
      })}
    </div>
  );
};
